import { render, staticRenderFns } from "./message_convert.vue?vue&type=template&id=2fe10a06&scoped=true"
import script from "./message_convert.vue?vue&type=script&lang=ts"
export * from "./message_convert.vue?vue&type=script&lang=ts"
import style0 from "./message_convert.vue?vue&type=style&index=0&id=2fe10a06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe10a06",
  null
  
)

export default component.exports